import {
  IPageContext,
  SERVICE_TYPES,
  ITaxonomyService,
} from '@glidecms/deliver-core-dev/types/services'
import { getTaxonomyAncestor } from '../../../helpers/createTaxonomyAncestor'
/*  TODO: CD-301 - Change return types on getTaxonomyForThirdSectionSlug & getTaxonomyForFirstSectionSlug
    back to ITaxonomy once Glide Deliver (curr v1.6.2) has been updated to include the seoData key
    import { ITaxonomy } from '@glidecms/deliver-core-dev/types/domain'
*/

export const getTaxonomyForPrimarySection = (context: IPageContext): any => {
  const { slug, parentId } = context.getPrimarySection()

  if (!slug) {
    throw new Error('primary section not found from context')
  }

  return getTaxonomyForSlug(context, slug, parentId)
}

export const getTaxonomyIdForPrimarySection = (context: IPageContext): number => {
  const { slug, parentId } = context.getPrimarySection()

  if (!slug) {
    throw new Error('primary section not found from context')
  }

  const { id } = getTaxonomyForSlug(context, slug, parentId)

  return id
}

const getTaxonomyForSlug = (context: IPageContext, slug: string, parentId: number) => {
  const taxonomyService = context.getService<ITaxonomyService>(SERVICE_TYPES.ITaxonomyService)
  const ancestor = getTaxonomyAncestor(slug, parentId)
  const taxonomy = taxonomyService.getTaxonomyBySlug(slug, ancestor) as any

  if (!taxonomy) {
    throw new Error(`taxonomy not found for slug: ${slug}`)
  }

  return taxonomy
}
